export abstract class LanguageService {
    readonly SUPPORTED_LANGUAGES: string[] = ['fr', 'de', 'en-GB'];

    public abstract getLanguage(defaultLanguage: string): string;
}
